import React, { Component } from "react";
import Translate, { reactTranslateChangeLanguage } from "translate-components";
import './style.css'
import Advantages from "../../Basic/TrustBlocks/Advantages";
import LogoRed from '../../DynamicContent/About/dsideLogo.svg';
import Footer from '../../Basic/Footer/index';
import About from '../../DynamicContent/Main/About__block/index';

class Forge extends Component {
    constructor() {
        super();

        this.state = {};
    }
  componentDidMount(){
  this.setState({lang: localStorage.getItem('lang')});
  }

  render(){

let newDate = new Date();
let nextDate = new Date();
let finishDate = new Date();
let time = new Date().toLocaleTimeString('en-US', { hour12: false, hour: "numeric", minute: "numeric"});
let hours = time;
let gtmsign = (newDate.getTimezoneOffset() < 0) ? '+':'';
let utcOffset = 'GMT' + gtmsign + (- (newDate.getTimezoneOffset() / 60));
let options = { month: 'short', day: '2-digit', year: 'numeric', weekday: "long" };
let today = new Intl.DateTimeFormat(this.state.lang, options).format(newDate.getFullDate);
var dateValue = nextDate.getDate() + 2;
var dateValue2 = finishDate.getDate() + 5;
nextDate.setDate(dateValue);
finishDate.setDate(dateValue2);
	  console.log(nextDate);
let tomorrow = new Intl.DateTimeFormat(this.state.lang, options).format(nextDate);
let tomo = new Intl.DateTimeFormat(this.state.lang, options).format(finishDate);
	  console.log(tomorrow);
    return (
     <div className="forgepage">
      <div className="forge-intro">
        <div className="row">
            <h2><span><img className="logo-forge-intro" src={LogoRed} width={130}/> Forge</span></h2>
        </div>
      </div>
      <div className="forge-short-descr">
        <div className="row">
            <div className="shortdescr">
            <h4><Translate>What is Forge and What Is It For?</Translate></h4>
            <p><Translate>Forge is our innovative system that we have developed to instantly track order status and project development.</Translate></p>
            </div>
        </div>
      </div>
      <div className="forge-item-descr">
        <div className="row">
            <div className="item-descr-tl">
<svg className="img-timeline" viewBox="0 0 400 384.8"  >
<line id="XMLID_41_" className="fotl0" x1="191.2" y1="22.8" x2="67.5" y2="362.7"/>
<line id="XMLID_103_" className="fotl1" x1="173.5" y1="71.4" x2="121.9" y2="213.3"/>
<line id="XMLID_40_" className="fotl0" x1="195.8" y1="10.3" x2="193.1" y2="17.5"/>
<line id="XMLID_39_" className="fotl0" x1="65.6" y1="367.9" x2="63" y2="375.2"/>
<line id="XMLID_38_" className="fotl0" x1="199.4" y1="0.2" x2="197.8" y2="4.8"/>
<line id="XMLID_37_" className="fotl0" x1="61.2" y1="380.1" x2="59.5" y2="384.7"/>
<g id="XMLID_63_">
	<g id="XMLID_84_">
		<text id="XMLID_36_" transform="matrix(0.9397 0 -0.342 0.9397 204.0129 72.671)" className="fotl2 fotl3 fotl4">Design</text>
		<text id="XMLID_35_" transform="matrix(0.9397 0 -0.342 0.9397 199.7697 43.1679)" className="fotl2 fotl3 fotl4">{today}</text>
		<text id="XMLID_34_" transform="matrix(0.9397 0 -0.342 0.9397 146.1183 190.5739)" className="fotl2 fotl3 fotl4">{tomorrow}</text>
		<text id="XMLID_33_" transform="matrix(0.9397 0 -0.342 0.9397 198.4538 87.9446)" className="fotl2 fotl5 fotl6">Confirmation required</text>
		<text id="XMLID_32_" transform="matrix(0.9397 0 -0.342 0.9397 104.122 71.6817)" className="fotl7 fotl5 fotl8">{hours} ({utcOffset})</text>
		<text id="XMLID_31_" transform="matrix(0.9397 0 -0.342 0.9397 48.4643 219.2098)" className="fotl7 fotl5 fotl8">18:00 ({utcOffset})</text>
		<text id="XMLID_102_" transform="matrix(0.9397 0 -0.342 0.9397 11.2386 327.1826)" className="fotl7 fotl5 fotl8">11:00 ({utcOffset})</text>
		<text id="XMLID_30_" transform="matrix(0.9397 0 -0.342 0.9397 136.1038 219.2208)" className="fotl2 fotl3 fotl4">Layout markup &amp; programming</text>
		<text id="XMLID_29_" transform="matrix(0.9397 0 -0.342 0.9397 131.1232 232.9051)"><tspan x="0" y="0" className="fotl2 fotl5 fotl6">We’re prepearing a bright cross-platform markup </tspan><tspan x="0" y="13.5" className="fotl2 fotl5 fotl6">and programming animations for your website.</tspan></text>
		<text id="XMLID_99_" transform="matrix(0.9397 0 -0.342 0.9397 106.4944 299.4397)" className="fotl2 fotl3 fotl4">{tomo}</text>
		<text id="XMLID_98_" transform="matrix(0.9397 0 -0.342 0.9397 96.4796 328.0875)" className="fotl2 fotl3 fotl4">Launching</text>
		<text id="XMLID_97_" transform="matrix(0.9397 0 -0.342 0.9397 91.4993 341.7708)" className="fotl2 fotl5 fotl6">Presentation of the finished product. Release date.</text>
		<text id="XMLID_28_" transform="matrix(0.9397 0 -0.342 0.9397 175.1532 111.9334)" className="fotl2 fotl5 fotl6">We’ve created a spectacular design for you.</text>
	</g>
	<path id="XMLID_27_" className="fotl9" d="M359.6,152.5h-78.2c-0.9,0-1.3-0.7-1-1.6l7.4-20.3c0.3-0.9,1.3-1.6,2.2-1.6h78.2
		c0.9,0,1.3,0.7,1,1.6l-7.4,20.3C361.5,151.8,360.5,152.5,359.6,152.5z"/>
	<g id="XMLID_79_">
		<path id="XMLID_80_" className="fotl10" d="M187.7,89.8c-2.4,0-3.6-1.9-2.7-4.3c0.9-2.4,3.5-4.3,5.8-4.3c2.4,0,3.6,1.9,2.7,4.3
			C192.7,87.8,190.1,89.8,187.7,89.8z M190.5,82c-1.9,0-4.1,1.6-4.8,3.5c-0.7,1.9,0.3,3.5,2.2,3.5c1.9,0,4.1-1.6,4.8-3.5
			C193.5,83.6,192.5,82,190.5,82z"/>
	</g>
	<g id="XMLID_77_">
		<path id="XMLID_24_" className="fotl10" d="M189.1,85.9c-0.2,0-0.3-0.2-0.2-0.4l0.6-1.6c0.1-0.2,0.3-0.4,0.5-0.4c0.2,0,0.3,0.2,0.2,0.4
			l-0.6,1.6C189.6,85.7,189.3,85.9,189.1,85.9z"/>
	</g>
	<g id="XMLID_75_">
		<path id="XMLID_23_" className="fotl10" d="M188.6,87.4c-0.2,0-0.3-0.2-0.2-0.4c0.1-0.2,0.3-0.4,0.5-0.4h0c0.2,0,0.3,0.2,0.2,0.4
			C189,87.3,188.8,87.4,188.6,87.4z"/>
	</g>
	<g id="XMLID_71_">
		<path id="XMLID_72_" className="fotl11" d="M293.8,144.3c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1,0-0.2,0-0.3l1.1-1.7c0-0.1,0.1-0.1,0.1-0.1
			l5.8-4.2c0.6-0.5,1.4-0.5,1.7,0c0.3,0.5,0,1.2-0.6,1.7l-5.8,4.2c-0.1,0-0.1,0.1-0.2,0.1L293.8,144.3
			C293.9,144.3,293.9,144.3,293.8,144.3z M295.3,142.4l-0.7,1.1l1.2-0.3l5.7-4.2c0.3-0.2,0.4-0.6,0.3-0.8s-0.5-0.2-0.8,0
			L295.3,142.4z"/>
	</g>
	<text id="XMLID_20_" transform="matrix(0.9397 0 -0.342 0.9397 307.4546 143.882)" className="fotl11 fotl3 fotl6">MAKE EDITS</text>
	<g id="XMLID_68_">
		<path id="XMLID_19_" className="fotl11" d="M191.6,74.8c-0.7,0-1.3-0.3-1.6-0.8c-0.7-1.1,0-2.8,1.4-3.8l4.9-3.6c0.5-0.4,1.1-0.6,1.6-0.6
			c0.5,0,0.9,0.2,1.2,0.6c0.5,0.8,0,2-1,2.7l-4.9,3.6c-0.6,0.5-1.4,0.5-1.6,0c-0.3-0.5,0-1.2,0.6-1.6l4.5-3.3c0.2-0.2,0.5-0.2,0.5,0
			c0.1,0.2,0,0.4-0.2,0.5l-4.5,3.3c-0.2,0.2-0.3,0.4-0.2,0.5c0.1,0.2,0.3,0.2,0.6,0l4.9-3.6c0.6-0.5,0.9-1.2,0.6-1.6
			c-0.3-0.4-1-0.4-1.6,0l-4.9,3.6c-1,0.8-1.5,2-1,2.7c0.5,0.8,1.7,0.8,2.7,0l4.9-3.6c0.2-0.2,0.5-0.2,0.5,0c0.1,0.2,0,0.4-0.2,0.5
			l-4.9,3.6C193.1,74.5,192.3,74.8,191.6,74.8z"/>
	</g>
	<path id="XMLID_18_" className="fotl12" d="M274.7,152.5h-61c-0.9,0-1.3-0.7-1-1.6l7.5-20.5c0.3-0.9,1.3-1.6,2.2-1.6h61
		c0.9,0,1.3,0.7,1,1.6l-7.5,20.5C276.5,151.8,275.6,152.5,274.7,152.5z"/>
	<path id="XMLID_17_" className="fotl11" d="M207.4,152.5h-19.8c-0.9,0-1.3-0.7-1-1.6l7.5-20.5c0.3-0.9,1.3-1.6,2.2-1.6H216
		c0.9,0,1.3,0.7,1,1.6l-7.5,20.5C209.3,151.8,208.3,152.5,207.4,152.5z"/>
	<path id="XMLID_16_" className="fotl13" d="M180.8,152.8h-19c-0.9,0-1.3-0.7-1-1.6l7.5-20.5c0.3-0.9,1.3-1.6,2.2-1.6h19
		c0.9,0,1.3,0.7,1,1.6l-7.5,20.5C182.7,152,181.7,152.8,180.8,152.8z"/>
	<text id="XMLID_15_" transform="matrix(0.9397 0 -0.342 0.9397 238.7499 143.8784)" className="fotl14 fotl3 fotl6">ACCEPT</text>
</g>
<path id="XMLID_14_" className="fotl15" d="M188.7,39.8c-0.7,1.9-2.8,3.5-4.8,3.5c-1.9,0-2.9-1.6-2.2-3.5c0.7-1.9,2.8-3.5,4.8-3.5
	S189.4,37.9,188.7,39.8z"/>
<path id="XMLID_13_" className="fotl15" d="M135.1,187.1c-0.7,1.9-2.8,3.5-4.8,3.5c-1.9,0-2.9-1.6-2.2-3.5c0.7-1.9,2.8-3.5,4.8-3.5
	C134.8,183.6,135.8,185.1,135.1,187.1z"/>
<path id="XMLID_12_" className="fotl16" d="M177.3,68.8c-0.6,1.5-2.3,2.8-3.8,2.8s-2.3-1.3-1.8-2.8c0.6-1.5,2.3-2.8,3.8-2.8
	S177.8,67.2,177.3,68.8z"/>
<path id="XMLID_11_" className="fotl16" d="M123.7,216.1c-0.6,1.5-2.3,2.8-3.8,2.8s-2.3-1.3-1.8-2.8s2.3-2.8,3.8-2.8
	S124.2,214.5,123.7,216.1z"/>
<path id="XMLID_101_" className="fotl15" d="M95.6,295.6c-0.7,1.9-2.8,3.5-4.8,3.5s-2.9-1.6-2.2-3.5c0.7-1.9,2.8-3.5,4.8-3.5
	S96.3,293.7,95.6,295.6z"/>
<path id="XMLID_100_" className="fotl16" d="M84.1,324.6c-0.6,1.5-2.3,2.8-3.8,2.8s-2.3-1.3-1.8-2.8c0.6-1.5,2.3-2.8,3.8-2.8
	S84.7,323.1,84.1,324.6z"/>
<g id="SwzFN3.tif_1_">
	<g id="XMLID_53_">
		<path id="XMLID_56_" className="fotl14" d="M197.5,143.7c0,0,0-0.1,0-0.1c0.1-0.4,0.3-0.7,0.4-1.1c0-0.1,0-0.1,0-0.2
			c0-0.2-0.2-0.3-0.4-0.3c-0.2,0-0.4,0.2-0.5,0.4c-0.2,0.6-0.4,1.1-0.6,1.7c-0.1,0.3,0,0.5,0.3,0.5c1.4,0,2.8,0,4.1,0
			c0.9,0,1.8,0,2.7,0c0.3,0,0.5-0.2,0.6-0.4c0.2-0.6,0.4-1.2,0.6-1.8c0.1-0.2,0-0.3-0.2-0.4c-0.3-0.1-0.6,0.1-0.7,0.4
			c-0.1,0.4-0.3,0.8-0.4,1.2c0,0,0,0.1,0,0.1C201.5,143.7,199.5,143.7,197.5,143.7z M201.8,141.3c0-0.1,0-0.1,0-0.1
			c0.2-0.7,0.5-1.3,0.7-2c0.2-0.7,0.5-1.3,0.7-2c0.1-0.3,0-0.5-0.3-0.4c-0.2,0-0.4,0.2-0.5,0.5c-0.5,1.3-1,2.6-1.4,4
			c0,0,0,0.1,0,0.1c0,0,0-0.1-0.1-0.1c-0.2-0.3-0.4-0.6-0.5-0.8c-0.1-0.2-0.4-0.2-0.6,0c-0.2,0.2-0.3,0.4-0.2,0.6
			c0.4,0.6,0.7,1.1,1.1,1.7c0.1,0.2,0.4,0.2,0.6,0c0.8-0.6,1.5-1.1,2.3-1.7c0.2-0.2,0.3-0.4,0.2-0.6c-0.1-0.2-0.4-0.2-0.6,0
			c-0.4,0.3-0.8,0.6-1.2,0.9C201.9,141.3,201.9,141.3,201.8,141.3z"/>
		<path id="XMLID_8_" className="fotl14" d="M197.5,143.7c2,0,4,0,6,0c0,0,0-0.1,0-0.1c0.1-0.4,0.3-0.8,0.4-1.2c0.1-0.3,0.5-0.5,0.7-0.4
			c0.2,0.1,0.2,0.2,0.2,0.4c-0.2,0.6-0.4,1.2-0.6,1.8c-0.1,0.2-0.3,0.4-0.6,0.4c-0.9,0-1.8,0-2.7,0c-1.4,0-2.8,0-4.1,0
			c-0.3,0-0.4-0.2-0.3-0.5c0.2-0.6,0.4-1.1,0.6-1.7c0.1-0.2,0.3-0.4,0.5-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.1,0,0.1,0,0.2
			c-0.1,0.4-0.3,0.7-0.4,1.1C197.6,143.6,197.6,143.6,197.5,143.7z"/>
		<path id="XMLID_7_" className="fotl14" d="M201.8,141.3c0.1,0,0.1-0.1,0.1-0.1c0.4-0.3,0.8-0.6,1.2-0.9c0.2-0.2,0.5-0.2,0.6,0
			c0.1,0.2,0,0.4-0.2,0.6c-0.8,0.6-1.5,1.1-2.3,1.7c-0.3,0.2-0.5,0.2-0.6,0c-0.4-0.6-0.7-1.1-1.1-1.7c-0.1-0.2,0-0.5,0.2-0.6
			c0.2-0.2,0.5-0.2,0.6,0c0.2,0.3,0.4,0.6,0.5,0.8c0,0,0,0.1,0.1,0.1c0-0.1,0-0.1,0-0.1c0.5-1.3,1-2.6,1.4-4
			c0.1-0.3,0.3-0.4,0.5-0.5c0.3,0,0.4,0.2,0.3,0.4c-0.2,0.7-0.5,1.3-0.7,2c-0.2,0.7-0.5,1.3-0.7,2
			C201.9,141.2,201.8,141.3,201.8,141.3z"/>
	</g>
</g>
<g id="DHqD5V.tif_1_">
	<g id="XMLID_46_">
		<path id="XMLID_50_" className="fotl11" d="M176.8,137.6c0.9,0,1.6,0.3,2.2,0.8c0.7,0.6,1.1,1.3,1.4,2.1c0,0.1,0,0.1,0.1,0.2
			c0,0.1,0,0.3-0.1,0.4c-1.1,1-2.3,1.9-3.7,2.6c-0.9,0.4-1.8,0.6-2.6,0.5c-0.7-0.1-1.3-0.4-1.8-0.8c-0.7-0.6-1.1-1.4-1.4-2.2
			c0-0.1,0-0.3,0.1-0.4c1.1-1,2.2-1.8,3.5-2.5C175.2,137.8,176,137.6,176.8,137.6z M176.6,138.3c-0.6,0-1.3,0.2-2,0.5
			c-1.1,0.5-2,1.2-2.9,2c0,0,0,0.1,0,0.1c0.3,0.7,0.7,1.4,1.3,1.9c0.5,0.4,1.1,0.7,1.9,0.7c0.7,0,1.5-0.3,2.3-0.7
			c0.9-0.5,1.8-1.1,2.6-1.9c0.1,0,0.1-0.1,0-0.1c-0.3-0.7-0.7-1.4-1.3-1.9C177.9,138.5,177.3,138.3,176.6,138.3z"/>
		<path id="XMLID_47_" className="fotl11" d="M177.2,140.8c-0.3,0.9-1.3,1.6-2.2,1.6c-0.8,0-1.3-0.7-1-1.6c0.3-0.9,1.3-1.6,2.2-1.6
			C177.1,139.3,177.5,140,177.2,140.8z M176.5,140.8c0.2-0.5-0.1-0.9-0.6-0.9c-0.5,0-1,0.4-1.2,0.9c-0.2,0.5,0.1,0.9,0.6,0.9
			C175.8,141.7,176.3,141.3,176.5,140.8z"/>
	</g>
</g>
<g id="xWLxqU.tif_1_">
	<g id="XMLID_43_">
		<path id="XMLID_2_" className="fotl14" d="M232.6,136.3c0.1,0,0.3,0,0.4,0.1c0.3,0.1,0.5,0.1,0.8,0.3c0.2,0.1,0.2,0.3,0,0.5
			c-0.2,0.2-0.4,0.3-0.6,0.2c-0.3-0.2-0.7-0.3-1.2-0.3c-1.2,0-2.3,0.5-3.4,1.5c-1.4,1.4-1.9,3.1-1.1,4.3c0.7,1,2.3,1.2,3.9,0.4
			c1.1-0.5,1.9-1.4,2.5-2.4c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.2,0.3-0.4,0.5-0.4c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0
			c-0.1,0.2-0.1,0.4-0.2,0.5c0,0,0,0.1,0,0.1c-0.1,0.2-0.2,0.4-0.3,0.5c-1.4,2.5-4.7,4.2-6.9,2.9c-1-0.6-1.4-1.6-1.1-3
			c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.2-0.4,0.3-0.6c0.9-1.7,2.6-3,4.4-3.3c0.2,0,0.4-0.1,0.6-0.1
			C232.2,136.3,232.4,136.3,232.6,136.3z"/>
		<path id="XMLID_1_" className="fotl14" d="M236,137.4c-0.1,0.1-0.2,0.2-0.3,0.3c-1.6,1.2-3.3,2.4-4.9,3.6c-0.3,0.2-0.5,0.2-0.6,0
			c-0.2-0.4-0.5-0.7-0.7-1.1c-0.1-0.2,0-0.5,0.3-0.6c0.2-0.1,0.4-0.1,0.4,0.1c0.2,0.3,0.3,0.5,0.5,0.8c0,0,0,0,0.1,0.1
			c0,0,0.1-0.1,0.1-0.1c1.5-1.1,3-2.2,4.6-3.4c0.3-0.2,0.6-0.2,0.6,0.2C236,137.3,236,137.3,236,137.4
			C236,137.4,236,137.4,236,137.4z"/>
	</g>
</g>
</svg>

            <div className="timeline-descr">
                <h4><Translate>Timeline</Translate></h4>
                <p><Translate>Your office will have a complete list of all stages with the dates and time of the readiness of your project.</Translate></p>
            </div>
            </div>
        </div>
      </div><div className="forge-item-descr ">
        <div className="row">
            <div className="item-descr-tl item-reverse">
<svg className="img-timeline" viewBox="0 0 400 384.8"  >

<g id="XMLID_14_">
	<g id="XMLID_23_">
		<path id="XMLID_12_" class="fgcl1" d="M272.8,261c-20.1,25.4-51.1,41.7-85.9,41.7c-60.5,0-109.6-49-109.6-109.6
			c0-60.1,48.5-108.9,108.5-109.5V62.6c-71.7,0.6-129.6,58.8-129.6,130.6c0,72.1,58.5,130.6,130.6,130.6c41.8,0,79-19.7,102.9-50.3
			L272.8,261z"/>
		<rect id="XMLID_13_" x="35.7" y="140.5" class="fgcl2" width="307" height="92"/>

		<path id="XMLID_2_" class="fgcl0" d="M339.8,233.2H38.4c-2.3,0-4.1-1.8-4.1-4.1v-85.5c0-2.3,1.8-4.1,4.1-4.1h301.3
			c2.3,0,4.1,1.8,4.1,4.1v85.5C343.9,231.3,342.1,233.2,339.8,233.2z M38.4,141c-1.4,0-2.6,1.1-2.6,2.6v85.5c0,1.4,1.1,2.6,2.6,2.6
			h301.3c1.4,0,2.6-1.1,2.6-2.6v-85.5c0-1.4-1.1-2.6-2.6-2.6H38.4z"/>

	</g>
	<g id="XMLID_15_">
		<path id="XMLID_9_" class="fgcl5" d="M81.9,162.5c13.4-0.1,24.3,10.7,24.4,24c0,5.7-1.9,10.9-5.1,15l3.8,2.7
			c3.8-4.9,6.1-11.1,6-17.8c-0.1-15.9-13.1-28.8-29-28.7c-0.1,0-0.2,0-0.2,0l0,4.7C81.7,162.5,81.8,162.5,81.9,162.5z"/>

		<path id="XMLID_17_" class="fgcl3" d="M185.8,83.7c60.6-0.4,110,48.4,110.4,108.9c0.2,25.7-8.6,49.3-23.2,68.1L290,273
			c17.2-22.3,27.4-50.2,27.2-80.5c-0.5-72.2-59.4-130.4-131.6-129.9c-0.4,0,0.3,0-0.1,0L185.8,83.7C186,83.6,185.4,83.7,185.8,83.7z
			"/>
		<path id="XMLID_10_" class="fgcl4" d="M101,201.6c-4.4,5.6-11.3,9.2-19,9.2c-13.4,0-24.2-10.8-24.2-24.2c0-13.3,10.7-24.1,24-24.2
			v-4.7c-15.8,0.1-28.6,13-28.6,28.8c0,15.9,12.9,28.9,28.9,28.9c9.2,0,17.4-4.4,22.7-11.1L101,201.6z"/>

		<text id="XMLID_8_" transform="matrix(1 0 0 1 63.4658 190.2281)" class="fgcl6 fgcl7">35%</text>
		<text id="XMLID_7_" transform="matrix(1 0 0 1 69.7644 199.2399)" class="fgcl8 fgcl6 fgcl9">design</text>
		<text id="XMLID_6_" transform="matrix(1 0 0 1 118.8719 169.3625)" class="fgcl10 fgcl6 fgcl11">Order status</text>
		<text id="XMLID_5_" transform="matrix(1 0 0 1 118.8719 210.388)"><tspan x="0" y="0" class="fgcl10 fgcl6 fgcl12">2 days </tspan><tspan x="58.7" y="0" class="fgcl10 fgcl13 fgcl12">/</tspan><tspan x="66" y="0" class="fgcl10 fgcl13 fgcl14">the next stage</tspan></text>
		<text id="XMLID_1_" transform="matrix(1 0 0 1 118.8719 186.5856)" class="fgcl13 fgcl14">Stage “Design”</text>
	</g>
</g>
</svg>

            <div className="timeline-descr">
                <h4><Translate>Order status</Translate></h4>
                <p><Translate>This element reflects the current state of the order, the percentage of readiness and tracking the stages of the project implementation process.</Translate></p>
            </div>
            </div>
        </div>
      </div>
		 <div className="forge-item-descr ">
        <div className="row">
            <div className="item-descr-tl">
<svg className="img-timeline" viewBox="0 0 400 384.8"  >
<g id="XMLID_126_">
	<g id="XMLID_234_">
		<path id="XMLID_241_" class="docsf0" d="M167.9,138.4C167.8,138.3,167.8,138.3,167.9,138.4l-6.8-3.7c0,0,0,0,0,0
			c-0.1-0.1-0.3-0.1-0.4,0l-11.6,4.2c-1.7,0.6-2.6,2.5-2,4.2l6.9,19.1c0.6,1.7,2.5,2.6,4.2,2l13.8-5c1.7-0.6,2.6-2.5,2-4.2l-6-16.3
			C168,138.5,168,138.5,167.9,138.4C167.9,138.4,167.9,138.4,167.9,138.4z M161.9,136.4l4.3,2.3l-3.1,1.1L161.9,136.4z M171.6,158.2
			l-13.8,5c-1.1,0.4-2.4-0.2-2.8-1.3l-6.9-19.1c-0.4-1.1,0.2-2.4,1.3-2.8l11.1-4l1.7,4.8c0.1,0.3,0.4,0.4,0.7,0.3l0,0l4.2-1.5
			l5.8,15.8C173.4,156.5,172.8,157.7,171.6,158.2L171.6,158.2z"/>
		<path id="XMLID_240_" class="docsf0" d="M152,145l4.6-1.7c0.3-0.1,0.4-0.4,0.3-0.7s-0.4-0.4-0.7-0.3l0,0l-4.6,1.7
			c-0.3,0.1-0.4,0.4-0.3,0.7C151.4,145,151.7,145.1,152,145z"/>
		<path id="XMLID_239_" class="docsf0" d="M161.1,156l-4.6,1.7c-0.3,0.1-0.4,0.4-0.3,0.7c0.1,0.3,0.4,0.4,0.7,0.3l4.6-1.7
			c0.3-0.1,0.4-0.4,0.3-0.7S161.4,155.9,161.1,156L161.1,156z"/>
		<path id="XMLID_238_" class="docsf0" d="M165.1,143l-12.3,4.5c-0.3,0.1-0.4,0.4-0.3,0.7c0.1,0.3,0.4,0.4,0.7,0.3l12.3-4.5
			c0.3-0.1,0.4-0.4,0.3-0.7C165.7,143,165.4,142.9,165.1,143L165.1,143z"/>
		<path id="XMLID_237_" class="docsf0" d="M166.1,145.6l-12.3,4.5c-0.3,0.1-0.4,0.4-0.3,0.7c0.1,0.3,0.4,0.4,0.7,0.3l12.3-4.5
			c0.3-0.1,0.4-0.4,0.3-0.7C166.7,145.6,166.3,145.5,166.1,145.6L166.1,145.6z"/>
		<path id="XMLID_236_" class="docsf0" d="M167,148.1l-12.3,4.5c-0.3,0.1-0.4,0.4-0.3,0.7c0.1,0.3,0.4,0.4,0.7,0.3l12.3-4.5
			c0.3-0.1,0.4-0.4,0.3-0.7C167.6,148.2,167.3,148,167,148.1L167,148.1L167,148.1z"/>
		<path id="XMLID_235_" class="docsf0" d="M167.9,150.7l-12.3,4.5c-0.3,0.1-0.4,0.4-0.3,0.7c0.1,0.3,0.4,0.4,0.7,0.3l12.3-4.5
			c0.3-0.1,0.4-0.4,0.3-0.7C168.5,150.7,168.2,150.6,167.9,150.7L167.9,150.7L167.9,150.7z"/>
	</g>
</g>
<g id="XMLID_103_">
	<g id="XMLID_225_">
		<path id="XMLID_232_" class="docsf0" d="M157.2,109.1C157.2,109.1,157.2,109.1,157.2,109.1l-6.8-3.7c0,0,0,0,0,0
			c-0.1-0.1-0.3-0.1-0.4,0l-11.6,4.2c-1.7,0.6-2.6,2.5-2,4.2l6.9,19.1c0.6,1.7,2.5,2.6,4.2,2l13.8-5c1.7-0.6,2.6-2.5,2-4.2l-6-16.3
			C157.4,109.3,157.3,109.2,157.2,109.1C157.3,109.2,157.2,109.2,157.2,109.1z M151.2,107.1l4.3,2.3l-3.1,1.1L151.2,107.1z
			 M161,128.9l-13.8,5c-1.1,0.4-2.4-0.2-2.8-1.3l-6.9-19.1c-0.4-1.1,0.2-2.4,1.3-2.8l11.1-4l1.7,4.8c0.1,0.3,0.4,0.4,0.7,0.3l0,0
			l4.2-1.5l5.8,15.8C162.7,127.2,162.1,128.5,161,128.9L161,128.9z"/>
		<path id="XMLID_231_" class="docsf0" d="M141.3,115.8l4.6-1.7c0.3-0.1,0.4-0.4,0.3-0.7s-0.4-0.4-0.7-0.3l0,0l-4.6,1.7
			c-0.3,0.1-0.4,0.4-0.3,0.7S141,115.9,141.3,115.8z"/>
		<path id="XMLID_230_" class="docsf0" d="M150.5,126.8l-4.6,1.7c-0.3,0.1-0.4,0.4-0.3,0.7c0.1,0.3,0.4,0.4,0.7,0.3l4.6-1.7
			c0.3-0.1,0.4-0.4,0.3-0.7S150.8,126.7,150.5,126.8L150.5,126.8z"/>
		<path id="XMLID_229_" class="docsf0" d="M154.5,113.8l-12.3,4.5c-0.3,0.1-0.4,0.4-0.3,0.7s0.4,0.4,0.7,0.3l12.3-4.5
			c0.3-0.1,0.4-0.4,0.3-0.7S154.8,113.7,154.5,113.8L154.5,113.8z"/>
		<path id="XMLID_228_" class="docsf0" d="M155.4,116.3l-12.3,4.5c-0.3,0.1-0.4,0.4-0.3,0.7s0.4,0.4,0.7,0.3l12.3-4.5
			c0.3-0.1,0.4-0.4,0.3-0.7S155.7,116.2,155.4,116.3L155.4,116.3z"/>
		<path id="XMLID_227_" class="docsf0" d="M156.4,118.9l-12.3,4.5c-0.3,0.1-0.4,0.4-0.3,0.7s0.4,0.4,0.7,0.3l12.3-4.5
			c0.3-0.1,0.4-0.4,0.3-0.7C157,118.9,156.6,118.8,156.4,118.9L156.4,118.9L156.4,118.9z"/>
		<path id="XMLID_226_" class="docsf0" d="M157.3,121.5l-12.3,4.5c-0.3,0.1-0.4,0.4-0.3,0.7c0.1,0.3,0.4,0.4,0.7,0.3l12.3-4.5
			c0.3-0.1,0.4-0.4,0.3-0.7S157.6,121.4,157.3,121.5L157.3,121.5L157.3,121.5z"/>
	</g>
</g>
<g id="XMLID_40_">
	<g id="XMLID_311_">
		<path id="XMLID_318_" class="docsf1" d="M211.5,136.2c0-0.1-0.1-0.1-0.1-0.2l-9.5-10.7c0,0,0,0,0,0c-0.2-0.2-0.5-0.3-0.8-0.3h-23.3
			c-3.4,0-6.2,2.8-6.2,6.2v38.2c0,3.4,2.8,6.2,6.2,6.2h27.6c3.4,0,6.2-2.8,6.2-6.2v-32.8c0-0.1,0-0.3-0.1-0.4
			C211.5,136.3,211.5,136.2,211.5,136.2z M202.1,128.8l6.1,6.9h-6.1V128.8z M205.4,173.6h-27.6c-2.3,0-4.2-1.9-4.2-4.2v-38.2
			c0-2.3,1.9-4.2,4.2-4.2H200v9.6c0,0.6,0.5,1,1,1l0,0h8.5v31.7C209.5,171.8,207.7,173.6,205.4,173.6L205.4,173.6z"/>
		<path id="XMLID_317_" class="docsf1" d="M179,137.7h9.2c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1l0,0H179c-0.6,0-1,0.5-1,1
			C178,137.3,178.4,137.7,179,137.7z"/>
		<path id="XMLID_316_" class="docsf1" d="M188.2,163H179c-0.6,0-1,0.5-1,1s0.5,1,1,1h9.2c0.6,0,1-0.5,1-1S188.8,163,188.2,163
			L188.2,163z"/>
		<path id="XMLID_315_" class="docsf1" d="M203.6,142.6H179c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1h24.6c0.6,0,1-0.5,1-1
			C204.7,143.1,204.2,142.6,203.6,142.6L203.6,142.6z"/>
		<path id="XMLID_314_" class="docsf1" d="M203.6,147.7H179c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1h24.6c0.6,0,1-0.5,1-1
			C204.7,148.2,204.2,147.7,203.6,147.7L203.6,147.7z"/>
		<path id="XMLID_313_" class="docsf1" d="M203.6,152.9H179c-0.6,0-1,0.5-1,1s0.5,1,1,1h24.6c0.6,0,1-0.5,1-1S204.2,152.9,203.6,152.9
			L203.6,152.9L203.6,152.9z"/>
		<path id="XMLID_312_" class="docsf1" d="M203.6,158H179c-0.6,0-1,0.5-1,1s0.5,1,1,1h24.6c0.6,0,1-0.5,1-1S204.2,158,203.6,158
			L203.6,158L203.6,158z"/>
	</g>
</g>
<g id="XMLID_43_">
	<g id="XMLID_299_">
		<path id="XMLID_306_" class="docsf1" d="M211.5,77.6c0-0.1-0.1-0.1-0.1-0.2l-9.5-10.7c0,0,0,0,0,0c-0.2-0.2-0.5-0.3-0.8-0.3h-23.3
			c-3.4,0-6.2,2.8-6.2,6.2v38.2c0,3.4,2.8,6.2,6.2,6.2h27.6c3.4,0,6.2-2.8,6.2-6.2V78.1c0-0.1,0-0.3-0.1-0.4
			C211.5,77.7,211.5,77.6,211.5,77.6z M202.1,70.2l6.1,6.9h-6.1V70.2z M205.4,115h-27.6c-2.3,0-4.2-1.9-4.2-4.2V72.6
			c0-2.3,1.9-4.2,4.2-4.2H200v9.6c0,0.6,0.5,1,1,1l0,0h8.5v31.7C209.5,113.2,207.7,115,205.4,115L205.4,115z"/>
		<path id="XMLID_305_" class="docsf1" d="M179,79.1h9.2c0.6,0,1-0.5,1-1s-0.5-1-1-1l0,0H179c-0.6,0-1,0.5-1,1S178.4,79.1,179,79.1z"/>
		<path id="XMLID_304_" class="docsf1" d="M188.2,104.4H179c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1h9.2c0.6,0,1-0.5,1-1
			C189.2,104.9,188.8,104.4,188.2,104.4L188.2,104.4z"/>
		<path id="XMLID_303_" class="docsf1" d="M203.6,84H179c-0.6,0-1,0.5-1,1s0.5,1,1,1h24.6c0.6,0,1-0.5,1-1S204.2,84,203.6,84L203.6,84z
			"/>
		<path id="XMLID_302_" class="docsf1" d="M203.6,89.1H179c-0.6,0-1,0.5-1,1s0.5,1,1,1h24.6c0.6,0,1-0.5,1-1S204.2,89.1,203.6,89.1
			L203.6,89.1z"/>
		<path id="XMLID_301_" class="docsf1" d="M203.6,94.3H179c-0.6,0-1,0.5-1,1s0.5,1,1,1h24.6c0.6,0,1-0.5,1-1S204.2,94.3,203.6,94.3
			L203.6,94.3L203.6,94.3z"/>
		<path id="XMLID_300_" class="docsf1" d="M203.6,99.4H179c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1h24.6c0.6,0,1-0.5,1-1
			C204.7,99.9,204.2,99.4,203.6,99.4L203.6,99.4L203.6,99.4z"/>
	</g>
</g>
<g id="XMLID_185_">
	<g id="XMLID_256_">
		<path id="XMLID_263_" class="docsf0" d="M234.4,147.5c0,0,0-0.1,0-0.1l-2.7-6.8c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.3l-11.3-4.1
			c-1.7-0.6-3.5,0.3-4.1,1.9l-6.7,18.5c-0.6,1.7,0.3,3.5,1.9,4.1l13.3,4.9c1.7,0.6,3.5-0.3,4.1-1.9l5.8-15.8
			C234.5,147.7,234.5,147.6,234.4,147.5C234.5,147.5,234.5,147.5,234.4,147.5z M231.2,142.3l1.8,4.4l-3-1.1L231.2,142.3z
			 M224.9,164.5l-13.3-4.9c-1.1-0.4-1.7-1.6-1.3-2.7l6.7-18.5c0.4-1.1,1.6-1.7,2.7-1.3l10.8,3.9l-1.7,4.7c-0.1,0.3,0,0.6,0.3,0.7
			l0,0l4.1,1.5l-5.6,15.3C227.3,164.4,226,164.9,224.9,164.5L224.9,164.5z"/>
		<path id="XMLID_262_" class="docsf0" d="M218.5,142.5l4.4,1.6c0.3,0.1,0.6,0,0.7-0.3c0.1-0.3,0-0.6-0.3-0.7l0,0l-4.4-1.6
			c-0.3-0.1-0.6,0-0.7,0.3C218.1,142.1,218.2,142.4,218.5,142.5z"/>
		<path id="XMLID_261_" class="docsf0" d="M218.5,156.4l-4.4-1.6c-0.3-0.1-0.6,0-0.7,0.3c-0.1,0.3,0,0.6,0.3,0.7l4.4,1.6
			c0.3,0.1,0.6,0,0.7-0.3C218.9,156.8,218.7,156.5,218.5,156.4L218.5,156.4z"/>
		<path id="XMLID_260_" class="docsf0" d="M229.5,149.2l-11.9-4.3c-0.3-0.1-0.6,0-0.7,0.3c-0.1,0.3,0,0.6,0.3,0.7l11.9,4.3
			c0.3,0.1,0.6,0,0.7-0.3C230,149.6,229.8,149.3,229.5,149.2L229.5,149.2z"/>
		<path id="XMLID_259_" class="docsf0" d="M228.6,151.7l-11.9-4.3c-0.3-0.1-0.6,0-0.7,0.3c-0.1,0.3,0,0.6,0.3,0.7l11.9,4.3
			c0.3,0.1,0.6,0,0.7-0.3C229.1,152.1,228.9,151.8,228.6,151.7L228.6,151.7z"/>
		<path id="XMLID_258_" class="docsf0" d="M227.7,154.2l-11.9-4.3c-0.3-0.1-0.6,0-0.7,0.3c-0.1,0.3,0,0.6,0.3,0.7l11.9,4.3
			c0.3,0.1,0.6,0,0.7-0.3C228.1,154.6,228,154.3,227.7,154.2L227.7,154.2L227.7,154.2z"/>
		<path id="XMLID_257_" class="docsf0" d="M226.8,156.7l-11.9-4.3c-0.3-0.1-0.6,0-0.7,0.3c-0.1,0.3,0,0.6,0.3,0.7l11.9,4.3
			c0.3,0.1,0.6,0,0.7-0.3S227.1,156.8,226.8,156.7L226.8,156.7L226.8,156.7z"/>
	</g>
</g>
<g id="XMLID_93_">
	<g id="XMLID_267_">
		<path id="XMLID_274_" class="docsf0" d="M244.8,119.2c0,0,0-0.1,0-0.1l-2.7-6.8c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.3l-11.3-4.1
			c-1.7-0.6-3.5,0.3-4.1,1.9l-6.7,18.5c-0.6,1.7,0.3,3.5,1.9,4.1l13.3,4.9c1.7,0.6,3.5-0.3,4.1-1.9l5.8-15.8
			C244.8,119.4,244.8,119.3,244.8,119.2C244.8,119.2,244.8,119.2,244.8,119.2z M241.6,113.9l1.8,4.4l-3-1.1L241.6,113.9z
			 M235.2,136.2l-13.3-4.9c-1.1-0.4-1.7-1.6-1.3-2.7l6.7-18.5c0.4-1.1,1.6-1.7,2.7-1.3l10.8,3.9l-1.7,4.7c-0.1,0.3,0,0.6,0.3,0.7
			l0,0l4.1,1.5l-5.6,15.3C237.6,136,236.3,136.6,235.2,136.2L235.2,136.2z"/>
		<path id="XMLID_273_" class="docsf0" d="M228.8,114.2l4.4,1.6c0.3,0.1,0.6,0,0.7-0.3s0-0.6-0.3-0.7l0,0l-4.4-1.6
			c-0.3-0.1-0.6,0-0.7,0.3C228.4,113.8,228.5,114.1,228.8,114.2z"/>
		<path id="XMLID_272_" class="docsf0" d="M228.8,128.1l-4.4-1.6c-0.3-0.1-0.6,0-0.7,0.3c-0.1,0.3,0,0.6,0.3,0.7l4.4,1.6
			c0.3,0.1,0.6,0,0.7-0.3C229.2,128.5,229.1,128.2,228.8,128.1L228.8,128.1z"/>
		<path id="XMLID_271_" class="docsf0" d="M239.9,120.9l-11.9-4.3c-0.3-0.1-0.6,0-0.7,0.3s0,0.6,0.3,0.7l11.9,4.3
			c0.3,0.1,0.6,0,0.7-0.3S240.1,121,239.9,120.9L239.9,120.9z"/>
		<path id="XMLID_270_" class="docsf0" d="M238.9,123.4L227,119c-0.3-0.1-0.6,0-0.7,0.3s0,0.6,0.3,0.7l11.9,4.3c0.3,0.1,0.6,0,0.7-0.3
			C239.4,123.8,239.2,123.5,238.9,123.4L238.9,123.4z"/>
		<path id="XMLID_269_" class="docsf0" d="M238,125.9l-11.9-4.3c-0.3-0.1-0.6,0-0.7,0.3c-0.1,0.3,0,0.6,0.3,0.7l11.9,4.3
			c0.3,0.1,0.6,0,0.7-0.3C238.5,126.3,238.3,126,238,125.9L238,125.9L238,125.9z"/>
		<path id="XMLID_268_" class="docsf0" d="M237.1,128.3l-11.9-4.3c-0.3-0.1-0.6,0-0.7,0.3s0,0.6,0.3,0.7l11.9,4.3
			c0.3,0.1,0.6,0,0.7-0.3C237.6,128.7,237.4,128.4,237.1,128.3L237.1,128.3L237.1,128.3z"/>
	</g>
</g>
<path id="XMLID_79_" class="docsf1" d="M211.6,227.9c0-0.1-0.1-0.1-0.1-0.2l-9.6-10.8c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.3-0.2
	c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.1h-23.5c-3.5,0-6.3,2.8-6.3,6.3v38.6c0,3.5,2.8,6.3,6.3,6.3h27.8c3.5,0,6.3-2.8,6.3-6.3
	v-33.1c0-0.1,0-0.3-0.1-0.4C211.7,228,211.7,227.9,211.6,227.9z M202.2,220.4l6.2,7h-6.2V220.4z M205.5,265.7h-27.8
	c-2.3,0-4.2-1.9-4.2-4.2v-38.6c0-2.3,1.9-4.2,4.2-4.2h22.4v9.7c0,0.6,0.5,1,1,1.1c0,0,0,0,0,0h8.5v32
	C209.7,263.8,207.8,265.7,205.5,265.7L205.5,265.7z"/>
<path id="XMLID_76_" class="docsf2" d="M199,234.1c-0.4-0.4-1.1-0.4-1.5,0l-9.4,9.4l-3.4-3.4c-0.4-0.4-1.1-0.4-1.5,0c0,0,0,0,0,0
	l-3.4,3.4c-0.4,0.4-0.4,1.1,0,1.5c0,0,0,0,0,0l7.4,7.4c0.4,0.4,1.1,0.4,1.5,0c0,0,0,0,0,0l13.6-13.6c0.4-0.4,0.4-1.1,0-1.5
	c0,0,0,0,0,0L199,234.1z M188,250.2l-5.9-5.9l1.9-1.9l3.4,3.4c0.4,0.4,1.1,0.4,1.5,0c0,0,0,0,0,0l9.4-9.4l1.8,1.8L188,250.2z"/>
<path id="XMLID_81_" class="docsf1" d="M211.6,287.9c0-0.1-0.1-0.1-0.1-0.2l-9.6-10.8c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.3-0.2
	c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.1h-23.5c-3.5,0-6.3,2.8-6.3,6.3v38.6c0,3.5,2.8,6.3,6.3,6.3h27.8c3.5,0,6.3-2.8,6.3-6.3
	v-33.1c0-0.1,0-0.3-0.1-0.4C211.7,288,211.7,287.9,211.6,287.9z M202.2,280.4l6.2,7h-6.2V280.4z M205.5,325.7h-27.8
	c-2.3,0-4.2-1.9-4.2-4.2v-38.6c0-2.3,1.9-4.2,4.2-4.2h22.4v9.7c0,0.6,0.5,1,1,1.1c0,0,0,0,0,0h8.5v32
	C209.7,323.8,207.8,325.7,205.5,325.7L205.5,325.7z"/>
<path id="XMLID_77_" class="docsf2" d="M199,294.1c-0.4-0.4-1.1-0.4-1.5,0l-9.4,9.4l-3.4-3.4c-0.4-0.4-1.1-0.4-1.5,0c0,0,0,0,0,0
	l-3.4,3.4c-0.4,0.4-0.4,1.1,0,1.5c0,0,0,0,0,0l7.4,7.4c0.4,0.4,1.1,0.4,1.5,0c0,0,0,0,0,0l13.6-13.6c0.4-0.4,0.4-1.1,0-1.5
	c0,0,0,0,0,0L199,294.1z M188,310.2l-5.9-5.9l1.9-1.9l3.4,3.4c0.4,0.4,1.1,0.4,1.5,0c0,0,0,0,0,0l9.4-9.4l1.8,1.8L188,310.2z"/>
<g id="XMLID_70_">
	<g id="XMLID_247_">
		<path id="XMLID_254_" class="docsf0" d="M255.1,90.8c0,0,0-0.1,0-0.1l-2.7-6.8c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.3l-11.3-4.1
			c-1.7-0.6-3.5,0.3-4.1,1.9l-6.7,18.5c-0.6,1.7,0.3,3.5,1.9,4.1l13.3,4.9c1.7,0.6,3.5-0.3,4.1-1.9l5.8-15.8
			C255.1,91,255.1,91,255.1,90.8C255.1,90.9,255.1,90.8,255.1,90.8z M251.9,85.6l1.8,4.4l-3-1.1L251.9,85.6z M245.5,107.9l-13.3-4.9
			c-1.1-0.4-1.7-1.6-1.3-2.7l6.7-18.5c0.4-1.1,1.6-1.7,2.7-1.3l10.8,3.9l-1.7,4.7c-0.1,0.3,0,0.6,0.3,0.7l0,0l4.1,1.5l-5.6,15.3
			C247.9,107.7,246.7,108.3,245.5,107.9L245.5,107.9z"/>
		<path id="XMLID_253_" class="docsf0" d="M239.1,85.9l4.4,1.6c0.3,0.1,0.6,0,0.7-0.3c0.1-0.3,0-0.6-0.3-0.7l0,0l-4.4-1.6
			c-0.3-0.1-0.6,0-0.7,0.3S238.8,85.8,239.1,85.9z"/>
		<path id="XMLID_252_" class="docsf0" d="M239.1,99.7l-4.4-1.6c-0.3-0.1-0.6,0-0.7,0.3s0,0.6,0.3,0.7l4.4,1.6c0.3,0.1,0.6,0,0.7-0.3
			S239.4,99.8,239.1,99.7L239.1,99.7z"/>
		<path id="XMLID_251_" class="docsf0" d="M250.2,92.5l-11.9-4.3c-0.3-0.1-0.6,0-0.7,0.3c-0.1,0.3,0,0.6,0.3,0.7l11.9,4.3
			c0.3,0.1,0.6,0,0.7-0.3C250.6,92.9,250.4,92.6,250.2,92.5L250.2,92.5z"/>
		<path id="XMLID_250_" class="docsf0" d="M249.3,95l-11.9-4.3c-0.3-0.1-0.6,0-0.7,0.3s0,0.6,0.3,0.7l11.9,4.3c0.3,0.1,0.6,0,0.7-0.3
			S249.5,95.1,249.3,95L249.3,95z"/>
		<path id="XMLID_249_" class="docsf0" d="M248.4,97.5l-11.9-4.3c-0.3-0.1-0.6,0-0.7,0.3c-0.1,0.3,0,0.6,0.3,0.7l11.9,4.3
			c0.3,0.1,0.6,0,0.7-0.3C248.8,97.9,248.6,97.6,248.4,97.5L248.4,97.5L248.4,97.5z"/>
		<path id="XMLID_248_" class="docsf0" d="M247.4,100l-11.9-4.3c-0.3-0.1-0.6,0-0.7,0.3s0,0.6,0.3,0.7l11.9,4.3c0.3,0.1,0.6,0,0.7-0.3
			S247.7,100.1,247.4,100L247.4,100L247.4,100z"/>
	</g>
</g>
<path id="XMLID_29_" class="docsf3" d="M367.6,233.4H35.9c-1.6,0-3-1.4-3-3v-74.9c0-1.6,1.4-3,3-3h331.7c1.6,0,3,1.4,3,3v74.9
	C370.6,232,369.3,233.4,367.6,233.4z"/>
<g id="XMLID_14_">
	<g id="XMLID_15_">
		<g id="XMLID_44_">
			<path id="XMLID_24_" class="docsf2" d="M354.2,206.8H284c-0.9,0-1.6-0.7-1.6-1.6v-23.9c0-0.9,0.7-1.6,1.6-1.6h70.2
				c0.9,0,1.6,0.7,1.6,1.6v23.9C355.8,206.1,355.1,206.8,354.2,206.8z"/>
			<path id="XMLID_23_" class="docsf4" d="M277.3,206.8h-23.1c-0.9,0-1.6-0.7-1.6-1.6v-23.9c0-0.9,0.7-1.6,1.6-1.6h23.1
				c0.9,0,1.6,0.7,1.6,1.6v23.9C278.9,206.1,278.2,206.8,277.3,206.8z"/>
			<g id="XMLID_54_">
				<path id="XMLID_5_" class="docsf4" d="M245.7,207.7h-19.6c-2,0-3.6-1.6-3.6-3.6v-21.3c0-2,1.6-3.6,3.6-3.6h19.6
					c2,0,3.6,1.6,3.6,3.6v21.3C249.3,206.1,247.7,207.7,245.7,207.7z M226.1,180.7c-1.2,0-2.2,1-2.2,2.2v21.3c0,1.2,1,2.2,2.2,2.2
					h19.6c1.2,0,2.2-1,2.2-2.2v-21.3c0-1.2-1-2.2-2.2-2.2H226.1z"/>
			</g>
			<text id="XMLID_22_" transform="matrix(1 0 0 1 309.3044 196.9121)" class="docsf3 docsf5 docsf6">ACCEPT</text>
			<g id="XMLID_49_">
				<path id="XMLID_2_" class="docsf7" d="M367.3,234.3H36c-2.1,0-3.8-1.7-3.8-3.8v-74.6c0-2.1,1.7-3.8,3.8-3.8h331.3
					c2.1,0,3.8,1.7,3.8,3.8v74.6C371.1,232.6,369.4,234.3,367.3,234.3z M36,153.9c-1.1,0-2,0.9-2,2v74.6c0,1.1,0.9,2,2,2h331.3
					c1.1,0,2-0.9,2-2v-74.6c0-1.1-0.9-2-2-2H36z"/>
			</g>
			<g id="XMLID_45_">
				<text id="XMLID_21_" transform="matrix(1 0 0 1 51.584 178.3882)" class="docsf1 docsf5 docsf8">Confirmation alert</text>
				<text id="XMLID_20_" transform="matrix(1 0 0 1 51.584 196.9383)" class="docsf9 docsf10">This stage requires your acceptation</text>
				<text id="XMLID_19_" transform="matrix(1 0 0 1 51.584 209.8072)" class="docsf9 docsf10">Please, accept or apply edits.</text>
			</g>
		</g>
		<g id="SwzFN3.tif">
			<g id="XMLID_38_">
				<path id="XMLID_41_" class="docsf3" d="M262.1,197c0-0.1,0-0.1,0-0.1c0-0.4,0-0.9,0-1.3c0-0.1,0-0.2,0-0.2
					c-0.1-0.2-0.3-0.4-0.5-0.3c-0.2,0-0.4,0.2-0.4,0.5c0,0.6,0,1.3,0,1.9c0,0.4,0.2,0.6,0.6,0.6c1.6,0,3.2,0,4.7,0c1,0,2,0,3,0
					c0.3,0,0.5-0.2,0.5-0.5c0-0.7,0-1.3,0-2c0-0.2-0.1-0.4-0.3-0.4c-0.3-0.1-0.6,0.1-0.6,0.5c0,0.4,0,0.9,0,1.3c0,0,0,0.1,0,0.1
					C266.7,197,264.4,197,262.1,197z M266,194.4c0-0.1,0-0.1,0-0.1c0-0.8,0-1.5,0-2.3c0-0.8,0-1.5,0-2.3c0-0.3-0.3-0.5-0.6-0.5
					c-0.3,0-0.4,0.2-0.4,0.5c0,1.5,0,3,0,4.5c0,0,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.1-0.1c-0.3-0.3-0.6-0.6-1-1
					c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7c0.6,0.6,1.3,1.3,1.9,1.9c0.2,0.2,0.5,0.2,0.7,0c0.6-0.6,1.3-1.3,1.9-1.9
					c0.2-0.2,0.2-0.5,0-0.7c-0.2-0.2-0.5-0.2-0.7,0c-0.3,0.3-0.7,0.7-1,1C266.1,194.3,266.1,194.3,266,194.4z"/>
				<path id="XMLID_16_" class="docsf3" d="M262.1,197c2.3,0,4.6,0,6.9,0c0,0,0-0.1,0-0.1c0-0.4,0-0.9,0-1.3c0-0.4,0.3-0.6,0.6-0.5
					c0.2,0.1,0.3,0.2,0.3,0.4c0,0.7,0,1.3,0,2c0,0.3-0.2,0.5-0.5,0.5c-1,0-2,0-3,0c-1.6,0-3.2,0-4.7,0c-0.4,0-0.6-0.2-0.6-0.6
					c0-0.6,0-1.3,0-1.9c0-0.2,0.2-0.4,0.4-0.5c0.2,0,0.5,0.1,0.5,0.3c0,0.1,0,0.2,0,0.2c0,0.4,0,0.9,0,1.3
					C262.1,196.9,262.1,197,262.1,197z"/>
				<path id="XMLID_13_" class="docsf3" d="M266,194.4c0.1-0.1,0.1-0.1,0.1-0.1c0.3-0.3,0.7-0.7,1-1c0.2-0.2,0.5-0.2,0.7,0
					c0.2,0.2,0.2,0.5,0,0.7c-0.6,0.6-1.3,1.3-1.9,1.9c-0.2,0.2-0.5,0.2-0.7,0c-0.6-0.6-1.3-1.3-1.9-1.9c-0.2-0.2-0.2-0.5,0-0.7
					c0.2-0.2,0.5-0.2,0.7,0c0.3,0.3,0.6,0.6,1,1c0,0,0.1,0.1,0.1,0.1c0-0.1,0-0.1,0-0.2c0-1.5,0-3,0-4.5c0-0.3,0.2-0.5,0.4-0.5
					c0.3,0,0.6,0.2,0.6,0.5c0,0.8,0,1.5,0,2.3c0,0.8,0,1.5,0,2.3C266,194.2,266,194.3,266,194.4z"/>
			</g>
		</g>
		<g id="DHqD5V.tif">
			<g id="XMLID_31_">
				<path id="XMLID_35_" class="docsf4" d="M235.9,190c1.1,0,2,0.3,2.9,0.9c1,0.6,1.8,1.5,2.5,2.4c0,0.1,0.1,0.1,0.1,0.2
					c0.1,0.1,0.1,0.3,0,0.4c-0.9,1.2-1.9,2.2-3.2,2.9c-0.9,0.5-1.8,0.7-2.8,0.6c-0.9-0.1-1.7-0.4-2.4-0.9c-1-0.7-1.9-1.6-2.6-2.6
					c-0.1-0.1-0.1-0.3,0-0.5c0.8-1.1,1.7-2.1,3-2.8C234.1,190.3,235,190.1,235.9,190z M235.9,190.8c-0.7,0-1.4,0.2-2.1,0.6
					c-1,0.6-1.8,1.4-2.5,2.3c0,0,0,0.1,0,0.1c0.6,0.8,1.4,1.6,2.2,2.1c0.7,0.5,1.5,0.8,2.4,0.7c0.8,0,1.6-0.3,2.3-0.8
					c0.9-0.6,1.6-1.3,2.2-2.1c0-0.1,0-0.1,0-0.1c-0.6-0.8-1.4-1.6-2.2-2.1C237.5,191.1,236.7,190.9,235.9,190.8z"/>
				<path id="XMLID_32_" class="docsf4" d="M237.7,193.8c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8
					C236.8,192,237.7,192.8,237.7,193.8z M236.9,193.8c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1
					C236.4,194.8,236.9,194.3,236.9,193.8z"/>
			</g>
		</g>
		<g id="xWLxqU.tif">
			<g id="XMLID_28_">
				<path id="XMLID_8_" class="docsf3" d="M299.1,188.6c0.2,0,0.4,0,0.5,0.1c0.3,0.1,0.7,0.2,1,0.3c0.2,0.1,0.3,0.3,0.2,0.6
					c-0.1,0.2-0.3,0.3-0.6,0.2c-0.5-0.2-1-0.3-1.5-0.3c-1.4,0-2.4,0.6-3.2,1.7c-1.1,1.5-0.9,3.6,0.5,4.9c1.2,1.2,3.1,1.4,4.6,0.5
					c1-0.6,1.6-1.5,1.8-2.7c0-0.3,0-0.6,0-0.9c0-0.3,0.1-0.4,0.4-0.5c0.2,0,0.4,0.1,0.5,0.3c0,0,0,0,0,0c0,0.2,0,0.4,0,0.6
					c0,0,0,0.1,0,0.1c0,0.2,0,0.4-0.1,0.6c-0.6,2.8-3.6,4.8-6.7,3.3c-1.4-0.7-2.3-1.9-2.5-3.5c0-0.2,0-0.3-0.1-0.5
					c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0.1-0.6c0.3-1.9,1.8-3.4,3.7-3.8c0.2,0,0.4-0.1,0.7-0.1C298.7,188.6,298.9,188.6,299.1,188.6z"
					/>
				<path id="XMLID_1_" class="docsf3" d="M303.4,189.9c0,0.1-0.1,0.2-0.2,0.3c-1.4,1.4-2.7,2.7-4.1,4.1c-0.2,0.2-0.5,0.2-0.7,0
					c-0.4-0.4-0.8-0.8-1.2-1.2c-0.2-0.2-0.2-0.5,0.1-0.7c0.2-0.1,0.4-0.1,0.5,0.1c0.3,0.3,0.6,0.6,0.9,0.9c0,0,0.1,0,0.1,0.1
					c0,0,0-0.1,0.1-0.1c1.3-1.3,2.6-2.6,3.8-3.8c0.3-0.3,0.6-0.2,0.8,0.2C303.4,189.8,303.4,189.8,303.4,189.9
					C303.4,189.8,303.4,189.8,303.4,189.9z"/>
			</g>
		</g>
	</g>
</g>
</svg>

            <div className="timeline-descr">
                <h4><Translate>Document management</Translate></h4>
                <p><Translate>All document management, except for the contract, takes place inside the system. Moreover, no personal presence is required in our office.</Translate></p>
            </div>
            </div>
        </div>
      </div>
           <Advantages />
           <About />
           <Footer />
     </div>
    );
  }
}


export default Forge;



// WEBPACK FOOTER //
// ./src/components/CompanyPages/Forge/index.js